import React from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslation } from "react-i18next";

const CustomerSelect = ({ value, onChange, loadOptions }) => {
  const { t } = useTranslation();
  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 22, color: '#1976d2', marginBottom: 12, fontWeight: 600 }}>
        {t("customer")}
      </h2>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        isClearable
        onChange={onChange}
        value={value}
        placeholder={t("search_customer_placeholder")}
        noOptionsMessage={() => t("no_customers_found") || "No customers found"}
        loadingMessage={() => t("loading") || "Loading..."}
        styles={{
          container: base => ({ ...base, marginBottom: 8, width: '100%' }),
          menu: base => ({ ...base, zIndex: 9999 })
        }}
      />
    </section>
  );
};

export default CustomerSelect;